import { Config } from './config'

export const config: Config = {
  environment: 'localDev',
  server: {
    portalApi: '/umbraco/api/'
  },
  app: {
    baseUrl: 'localhost',
    name: 'localDev'
  }
}